import { FontSize } from "../../assets/font";
import styled, { css } from "styled-components";
import withTheme from "@mui/styles/withTheme";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";

// Grid Components //
export const TermsAndConditionsContainer = styled(Grid)`
  && {
    max-width: 1280px;
    margin: auto;
    padding: 0 5%;
  }
`;

// Typography Components //
export const LabelStyled = styled(Typography)`
  && {
    font-weight: ${FontSize.regular};
    font-size: ${FontSize.desktopBody};
    line-height: 1.5rem;
    text-align: justify;

    ${(props) =>
      props.$list_item &&
      css`
        display: list-item;
        list-style-type: disc;
        margin: 0 0 0 20px;
      `}
  }
`;
export const Title = withTheme(styled(Typography)`
  && {
    font-size: ${FontSize.desktopHeadline};
    font-weight: ${FontSize.bold};
  }
`);
export const TitleStyled = styled(Typography)`
  && {
    font-size: ${FontSize.desktopTitle1};
    font-weight: ${FontSize.bold};
    text-align: center;
    margin: 40px 0 0;
  }
`;

// Card Components //
export const CardStyled = withTheme(styled(Card)`
  && {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    margin: 40px auto;

    ${(props) => props.theme.breakpoints.down("md")} {
      padding: 20px 10%;
    }

    ${(props) => props.theme.breakpoints.down("mobileL")} {
      padding: 20px 5%;
    }
  }
`);

// Misc. Components //
export const DividerStyled = styled.div`
  && {
    border-top: 1px solid #d6d6d6;
    width: 100%;
    margin: 30px auto;
  }
`;

// List Components //
export const ListStyled = styled.ol`
  && {
    list-style-type: none;
    counter-reset: item;
    margin: 0;
    padding: 0;

    li {
      display: table;
      counter-increment: item;
      margin-bottom: 0.6em;

      ol > li {
        margin: 10px 0;
      }

      ol > li:before {
        content: counters(item, ".") " ";
      }
    }

    li:before {
      content: counters(item, ".") ". ";
      display: table-cell;
      padding-right: 0.6em;
      font-weight: ${FontSize.bold};
    }
  }
`;
